export default __webpack_public_path__ + "static/media/AetherPhoto6.654cb431.jpg";